module.exports = __webpack_public_path__ + "media/promo/advent/images/next-5894e0d6e319d5c8c042d52deff101cd.jpg";